import React from "react"

function JackImage() {
    return (
        <div className="fourJokersHeader">
            <img className="fourJokersHeaderImage" src={"images/Detective-noir.jpg"} alt="silhouette of a private detective" />
        </div>
    )
}

export default JackImage